'use strict';

var _ = require('lodash');
var AlertsDrawerService = function AlertsDrawerService($q, $http, alertParameters, FetchUrl, dataRetrieverService, constants, searchCriteriaRsqlQueryService, SearchRule, scenarioService) {
  function getDataRetriever(screen, mode) {
    return dataRetrieverService.getDataRetriever(screen, mode + '-' + 'alerts');
  }
  function getClearDataRetriever(screen, mode) {
    return dataRetrieverService.getDataRetriever(screen, mode + '-' + 'alerts-clear');
  }
  function cloneDataRetriever(screen, mode) {
    var dataRetriever = getDataRetriever(screen, mode);
    return _.cloneDeep(dataRetriever);
  }
  function isMergedLegClassSegClassView(screen, mode) {
    return screen === constants.FLIGHT_SCREEN && mode === constants.CLASS_MODE;
  }
  function getAlertsData(screen, mode, entityData, reoptPreviewData) {
    var dataRetriever = cloneDataRetriever(screen, mode);
    var filterRules = alertParameters.searchCriteriaFor(mode, entityData);
    var additionalParameters = alertParameters.additionalParametersFor(mode, entityData);
    if (additionalParameters) {
      if (mode === constants.CLASS_MODE && _.isNil(additionalParameters.legId) && _.isNil(additionalParameters.cabinCode)) {
        return $q.when({});
      }
      dataRetriever.setRequestParameters(additionalParameters);
    }
    setScenario(dataRetriever, entityData, reoptPreviewData);
    return dataRetriever.localSortApplied().retrieveData('alerts-drawer-grid', filterRules);
  }
  function mergeAlerts(legClassAlerts, segClassAlerts) {
    var alerts = {};
    alerts.legClassesOwnScore = legClassAlerts.ownScore || 0;
    alerts.segmentClassesOwnScore = segClassAlerts.ownScore || 0;
    alerts.totalScore = (segClassAlerts.totalScore || 0) + (legClassAlerts.totalScore || 0);
    alerts.rules = _.without(_.concat(legClassAlerts.rules, segClassAlerts.rules), undefined);
    return alerts;
  }
  function getAlerts(entityData, screen, mode, reoptPreviewData) {
    if (!isMergedLegClassSegClassView(screen, mode)) {
      return getAlertsData(screen, mode, entityData, reoptPreviewData);
    }
    return getAlertsData(screen, constants.CLASS_MODE, entityData, reoptPreviewData).then(function (legClassAlerts) {
      return getAlertsData(screen, constants.SEGMENT_CLASS_MODE, entityData, reoptPreviewData).then(function (segClassAlerts) {
        return mergeAlerts(legClassAlerts, segClassAlerts);
      });
    });
  }
  function setScenario(dataRetriever, entityData, reoptPreviewData) {
    var scenario = checkIfReoptModeLoaded(reoptPreviewData) ? entityData.scenarioName : scenarioService.PUBLISHED;
    dataRetriever.scenarios([scenario]);
  }
  function checkIfReoptModeLoaded(reoptData) {
    return _.get(reoptData, 'mdReopt.read', false) || _.get(reoptData, 'ndReopt.read', false);
  }
  function makeRequest(postUrl) {
    return $http({
      method: 'POST',
      url: postUrl,
      cache: false
    });
  }
  function preparePOSTUrl(url, filter, requestParams) {
    var config = {};
    config.url = url;
    config.params = {};
    if (!_.isEmpty(filter)) {
      config.params.filter = filter;
    }
    _.extend(config.params, requestParams);
    return new FetchUrl(config).toString();
  }
  function createDefaultScenarioRule() {
    return new SearchRule({
      metaCategory: 'customScenarioRules',
      field: 'scenarioName',
      operator: '=',
      leftOperand: scenarioService.PUBLISHED
    });
  }
  function prepareRequest(screen, mode, entityData, technicalIds) {
    var filterRules = alertParameters.searchCriteriaFor(mode, entityData);
    filterRules = filterRules.concat(createDefaultScenarioRule());
    var filterString = searchCriteriaRsqlQueryService.getRsqlQueryFromSearchCriteriaRules(filterRules);
    var additionalParameters = alertParameters.additionalParametersFor(mode, entityData) || {};
    additionalParameters.alerts = technicalIds;
    var dataRetriever = getClearDataRetriever(screen, mode);
    dataRetriever.setRequestParameters(additionalParameters);
    var dataSource = dataRetriever.createDataSource(filterString);
    return preparePOSTUrl(dataSource.url, dataSource.rsqlQuery, dataSource.requestParameters);
  }
  function removeAlerts(technicalIds, entityData, screen, mode) {
    var url = prepareRequest(screen, mode, entityData, technicalIds);
    if (!isMergedLegClassSegClassView(screen, mode)) {
      return makeRequest(url);
    } else {
      return makeRequest(url).then(function () {
        url = prepareRequest(screen, constants.SEGMENT_CLASS_MODE, entityData, technicalIds);
        return makeRequest(url);
      });
    }
  }
  return {
    getAlerts: getAlerts,
    removeAlerts: removeAlerts
  };
};
AlertsDrawerService.$inject = ['$q', '$http', 'AlertParametersFactory', 'FetchUrlFactory', 'DataRetrieverService', 'DataRetrieverConstantsService', 'SearchCriteriaRsqlQueryService', 'SearchCriteriaRuleFactory', 'ScenarioService'];
module.exports = AlertsDrawerService;